







































































































































import {Component, Mixins} from "vue-property-decorator";
import QDetailModal from "@/components/qDetailModal.vue";
import Category from "@/model/category";
import Menu from "@/model/menu";
import NumberGenerator from "@/common/mixins/numberGenerator";
import OrderComponent from "@/components/order/orderComponent.vue";
import categoryApi from "@/api/categoryApi";
import itemApi from "@/api/itemApi";
import store from "@/store";
import {namespace} from "vuex-class";
import MenuSet from "@/model/menuSet";
import SetMenuItem from "@/model/setMenuItem";

const menuStore = namespace("MenuStore")
const optionStore = namespace("OptionStore")
const menuSetStore = namespace("MenuSetStore")
const setMenuItemStore = namespace("SetMenuItemStore")

@Component({
  name: "MenuList",
  components: {OrderComponent, QDetailModal},
})
export default class MenuList extends Mixins(NumberGenerator) {
  @menuStore.Getter
  getMenuList!: Menu[];
  @optionStore.Getter
  getOptionList!: Menu[];
  @menuSetStore.Getter
  getMenuSetList!: MenuSet[];
  @setMenuItemStore.Getter
  getSetMenuItemList!: SetMenuItem[];

  public categoriesStatusList: Category[] = null;
  public subCategoriesStatusList: Category[] = null;
  public menuTmp = new Menu();
  public menuList: Menu[] = null;
  public menuScrollList;
  public menuSetList: MenuSet[] = [];
  public aycdFlag = false;
  public menuTop = 0;
  public isOnStatusForCategory = "0";
  public isOnStatusForSubCategory = "0";
  private MARGIN_CSS_DEFAULT = 88;
  private subCategoryTarget = '';
  private isClickMenu = false;

  async mounted() {
    this.categoriesStatusList = await categoryApi.getMainCategories()
    this.subCategoriesStatusList = await categoryApi.getSubCategories()

    await this.initModule()
  }

  // todo: change to call it after scan QR
  async initModule() {
    const items = await itemApi.index()
    const setMenuList = await itemApi.getSetMenu()
    if ( this.getMenuList.length === 0 && items !== null) {
      items.map(value => {
        store.dispatch('MenuStore/addMenuToList', value);
      })
    }

    this.menuList = await store.dispatch('MenuStore/getAllMenu')

    // update the option of menu list
    const allMenu = await itemApi.getOptions()
    if ( this.getOptionList.length === 0 ) {
      allMenu.map(value => {
        store.dispatch('OptionStore/addOptionToList', value);
      })
    }

    if ( this.getMenuSetList.length === 0 && items !== null ) {
      items.map( async item => {
        const setMenus = await itemApi.getMenuSetListByIdentifier(item.identifier, setMenuList.setMenus, setMenuList.setMenuItemKeys, setMenuList.setMenuItems)
        setMenus.map(setMenu => {
          store.dispatch('MenuSetStore/addMenuSetToList', setMenu)

          if (setMenu.options) {
            setMenu.options.map(item => {
              store.dispatch('SetMenuItemStore/addSetMenuItemToList', item)
            })
          }
        })
      });
    }
  }

  public pageYOffset = 0;

  async created() {
    // if (!this.$isServer) {
    //   window.addEventListener('scroll', this._scrollListener)
    // }

    // todo: will update clear when unSub server.
    window.addEventListener('beforeunload', function() {
      store.dispatch('MenuStore/clearList');
    })
    window.addEventListener('beforeunload', function() {
      store.dispatch('OptionStore/clearList');
    })
    window.addEventListener('beforeunload', function() {
      store.dispatch('MenuSetStore/clearList');
    })
    window.addEventListener('beforeunload', function() {
      store.dispatch('SetMenuItemStore/clearList');
    })
  }

  // beforeDestroy() {
  //   window.removeEventListener('scroll', this._scrollListener)
  // }

  public isOnStatus(index, identifier, isCategory = false): string {
    const isCheckStatus = (isCategory) ? this.isOnStatusForCategory : this.isOnStatusForSubCategory
    if (index.toString() === "0" && isCheckStatus.toString() === "0") {
      return "on"
    } else if (identifier.toString() === isCheckStatus.toString()) {
      return "on"
    }
    return "";
  }

  public async changeMenu(identifier, isCategory = false) {
    const elementList = []
    if (!isCategory) {
      this.isClickMenu = true;
      this.subCategoryTarget = identifier;
      this.isOnStatusForSubCategory = identifier;

      const elements = this.$refs['menu_' + identifier.charAt(0)];

      if (typeof elements === 'object') {
        const itemList = Object.values(elements).map(item => [item])
        itemList.map(value => {
          if (value[0].id.toString().slice(14) === identifier.toString()) {
            elementList.push(value[0])
          }
        })
      }
    } else {
      const elements = this.$refs['menu_' + identifier.charAt(0)];
      if (typeof elements === 'object') {
        elementList.push(Object.values(elements).map(item => [item])[0][0])
      }
    }

    await this.updateStatusParams(identifier, isCategory)

    const menuFirst = elementList[0] as HTMLElement;
    this.menuTop = menuFirst.offsetTop
    window.scrollTo({
      top: this.menuTop - this.MARGIN_CSS_DEFAULT,
      behavior: "smooth"
    });
  }

  private async _scrollListener() {
    this.pageYOffset = Math.round(window.pageYOffset)
    let arrayScroll = [];
    const scrollCategories = this.categoriesStatusList
    scrollCategories.map((item) => {
      if (typeof this.$refs['menu_' + item.identifier] === 'object') {
        const itemScroll = Object.values(this.$refs['menu_' + item.identifier]).filter((item, key) => {
          if (key === 0) {
            return item
          }
        })
        if (!arrayScroll.includes(itemScroll)) {
          arrayScroll.push(itemScroll);
        }
      }
    })
    const checkElement = arrayScroll.filter(item => {
      if ((item[0] as HTMLElement).offsetTop <= this.pageYOffset + this.MARGIN_CSS_DEFAULT) {
        return item[0];
      }
    });
    let identifier = "";
    if ((checkElement && checkElement.length > 0)) {
      const element = checkElement[checkElement.length-1][0] as HTMLElement;
      identifier = element.id.charAt(14);
    }

    this.updateStatusParams(identifier)

    const targetPageY = (this.menuTop > 0) ? this.menuTop - this.MARGIN_CSS_DEFAULT : 0
    if (targetPageY === this.pageYOffset) {
      this.isClickMenu = false
    }
  }

  private async updateStatusParams(identifier, isCategory = false) {
    if (this.isOnStatusForCategory !== identifier) {
      this.isOnStatusForCategory = identifier;

      if (isCategory) {
        const identifierSub = await categoryApi.getFirstSubCategoryByIdentifier(identifier, this.subCategoriesStatusList)
        if (identifierSub !== []) {
          this.isOnStatusForSubCategory = identifierSub
        }
      }
    }

    if (!isCategory) {
      this.isOnStatusForCategory = identifier.charAt(0);
    }
  }

  public openMenuDetail(menu, isEdit = false) {
    if (this.getNameLabel(menu) === "not-aycd") {
      this.aycdFlag = true;
      this.menuTmp = menu;
    } else if (this.getNameLabel(menu) === "menu_detail" || isEdit === true) {
      this.detailModal(menu, isEdit);
    }
  }

  public detailModal(menu, isEdit) {
    this.aycdFlag = false;
    (this.$refs.qDetailModal as QDetailModal).show(menu, isEdit);
  }

  public getNameLabel(menu) {
    if (!menu.allYouCanEat) {
      return "not-aycd";
    } else {
      return "menu_detail"
    }
  }

  public isShowRecommended(value) {
    return !(value === "" || value === "0")
  }
}
